<template>
	<div>
		<div class="vote-btn" @click="goVote">{{lang.goVote}}</div>
		<div class="dialog-mask" v-show="showDialog">
			<div class="dialog-content" @touchmove.prevent>
				<img class="vote-dialog-bg" src="../assets/vote-dialog-bg.png" alt="">
				<img class="vote-dialog-close" src="../assets/vote-dialog-close.png" @click="closeDialog" alt="">
				<div class="text" v-if="jump2voteProps.isArab" dir="rtl">
					<span>تهانينا لقد اصبحت واحداً من</span>
					<span>{{fans_order}}</span>
					<span>من داعميه</span>
				</div>
				<div class="text" v-else>
					Congratulations on becoming his {{fans_order}} supporter
				</div>
				<button class="go" @click="jump2votePage">{{lang.go}}</button>
			</div>
		</div>
	</div>

</template>

<script>
    let original_lang = {
        en: {
            goVote: "Vote for me now",
            go: "GO"
        },
        ar: {
            goVote: "صوت لي الآن",
            go: "إضغط الآن"
        }
    };
    import {_di, iframeInsert} from "../common/js/di";
    // import {lang} from "../language/kol";
    export default {
        name: "Jump2vote",
        props: {
            jump2voteProps: {
                required: true
            }
        },
        data() {
            return {
                showDialog: false,
                fans_order: 0
            }
        },
        methods: {
            async goVote() {
                this.showDialog = true;
                this.eventTrack.goVote({
                    "user_id": this.jump2voteProps.userId,
                    "host_id": this.jump2voteProps.host_id,
                    "type": this.jump2voteProps.fromType,
                    "page": "KolBoardPage",
                    "title": "KolBoardPage"
                })
            },
	        //跳转到投票页
            jump2votePage() {
                let url = process.env.NODE_ENV === 'production' ? 'https://www.loopslive.com/web-loops/gz/loopsActives/ar/kol-fans-club/index.html' : 'https://www-test.loopslive.com/web-loops/gz/loopsActives/test/test-kol-fans-club/index.html'
                this.openUrl(url, 'Kol Fans Club')
                this.showDialog = false;
                this.eventTrack.jump2votePage({
                    "user_id": this.jump2voteProps.userId,
                    "host_id": this.jump2voteProps.host_id,
                    "type": this.jump2voteProps.fromType,
                    "page": "KolBoardPage",
                    "title": "KolBoardPage"
                })
            },
            closeDialog() {
                this.showDialog = false;
                this.eventTrack.closeDialog({
                    "user_id": this.jump2voteProps.userId,
                    "host_id": this.jump2voteProps.host_id,
                    "type": this.jump2voteProps.fromType,
                    "page": "KolBoardPage",
                    "title": "KolBoardPage"
                })
            },
            openUrl(url, title) {
                let link = `util/openUrl?url=${url}&title=${title}`;
                iframeInsert(link);
            },
            fetchFansOrder() {
                var url = process.env.KOLURL + "kol_fans/show_fans_order";
                var params = {
                    uid: this.jump2voteProps.userId,
                    token: this.jump2voteProps.token,
                    kol_id: this.jump2voteProps.host_id,
                };
                console.log(params);
                this.$axios.get(url, {params: params}).then(res => {
                    console.log(res.data);
                    this.fans_order = res.data.order;

                }).catch((err) => {
                    console.log(err);
                })
            }
        },
        computed: {
            lang() {
                return this.jump2voteProps.isArab ? original_lang['ar'] : original_lang['en']
            },

        },
        created() {
            this.fetchFansOrder();
        },
        mounted() {

            //di打点相关
            this.eventTrack = {
                goVote: _di('kol.goVote'),
                jump2votePage: _di('kol.jump2votePage'),
                closeDialog: _di('kol.closeDialog')
            }
        }
    }
</script>

<style scoped>
	.vote-btn {
		width: 3.2rem;
		height: 0.48rem;
		border-radius: 0.24rem;
		display: flex;
		align-items: center;
		justify-content: center;
		background-image: linear-gradient(to right, #74CB5F, #89D67C);
		color: #fff;
		font-size: 0.15rem;
		line-height: 0.2rem;
		font-weight: 600;
		margin: 0.2rem auto 0.3rem;
		/*box-shadow:0 12px 18px -12px #CEEE9C;*/
		box-shadow: 0 12px 0 -8px #CEEE9C;
	}

	.dialog-mask {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.7);
		position: fixed;
		z-index: 10;
		top: 0;
		left: 0;
		/*display: flex;*/
		/*align-items: center;*/
		/*justify-content: center;*/
		overflow: auto;
	}

	.dialog-content {
		position: relative;
		width: 2.7rem;
		/*min-height: 1.5rem;*/
		background-color: #fff;
		border-radius: 0.08rem;
		box-shadow: 0 3px 19px rgba(89, 89, 89, 0.85);
		animation: zoom-in 0.15s ease forwards;
		padding-top: 1.61rem;
		margin: 1.1rem auto 0;
		padding-bottom: 0.3rem;
	}

	.vote-dialog-bg {
		position: absolute;
		max-width: 2.94rem;
		width: 2.94rem;
		height: 1.61rem;
		left: 50%;
		margin-left: -1.48rem;
		top: 0;
	}

	.vote-dialog-close {
		position: absolute;
		z-index: 30;
		width: 0.14rem;
		height: 0.14rem;
		top: 0.1rem;
		right: 0.1rem;
	}

	.text {
		box-sizing: border-box;
		position: absolute;
		z-index: 20;
		width: 2.7rem;
		height: 1.61rem;
		line-height: 0.26rem;
		left: 0;
		top: 0;
		color: #fff;
		padding-left: 0.2rem;
		padding-right: 0.2rem;
		text-align: center;
		padding-top: 0.5rem;
	}

	.go {
		width: 1.9rem;
		height: 0.4rem;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 0.2rem;
		background-color: #74CC5E;
		color: #fff;
		font-size: 0.18rem;
		border: none;
		outline: none;
		margin: 0.5rem auto 0;
	}

	@keyframes zoom-in {
		from {
			opacity: 0;
			transform: scale3d(0.3, 0.3, 0.3);
		}
		50% {
			opacity: 1;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Jump2vote.vue